import { ReactNode, SyntheticEvent } from 'react';
/* eslint-disable no-restricted-imports */
import { styled, Tab, Tabs as MuiTabs } from '@mui/material';

import { I18nResources, Options, useI18n } from '@app-velocity/i18n';

export type TabsItem = {
  label: I18nResources;
  value: string;
  disabled?: boolean;
  labelOptions?: Options;
  badge?: ReactNode;
};

export type TabsListProps = {
  tabs: TabsItem[];
  value?: string;
  onChange?: (event: SyntheticEvent, value: string) => void;
};

const TabLabel = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

const TabBadge = styled('span')<{ active?: boolean }>(({ theme, active }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: theme.spacing(5),
  height: theme.spacing(5),
  padding: `0 ${theme.spacing(1.5)}`,
  borderRadius: theme.spacing(5),
  background: active
    ? 'var(--button-button-primary-color)'
    : 'var(--background-background-secondary-color)',
  border: active
    ? '1px solid var(--button-button-primary-color)'
    : '1px solid var(--stroke-stroke-primary-color)',
  color: active
    ? 'var(--button-button-primary-text-color)'
    : 'var(--text-text-secondary-color)',
  fontWeight: 500,
  fontSize: 12,
  lineHeight: 1,
}));

export const Tabs = ({ tabs, value, onChange }: TabsListProps) => {
  const { t } = useI18n();

  return (
    <MuiTabs value={value ?? false} onChange={onChange}>
      {tabs.map(({ label, value: tabValue, disabled, labelOptions, badge }) => (
        <Tab
          key={tabValue}
          value={tabValue}
          label={
            <TabLabel>
              {t(label, labelOptions) || tabValue}
              {badge != null ? (
                <TabBadge active={value === tabValue}>{badge}</TabBadge>
              ) : null}
            </TabLabel>
          }
          disabled={disabled}
          disableRipple
        />
      ))}
    </MuiTabs>
  );
};
